import React from 'react';
import './index.css';
import { useHistory } from 'react-router-dom';

const LandingPageBody = () => {
  let history = useHistory();
  let arr = Array.apply(null, { length: 6 }).map(Number.call, Number);
  return (
    <div>
      <div className="container-pm">
        <div className="d-flex flex-column px-4">
          <p className="pm-title"> Are you a Project Manager ? </p>
          <p>
            <i>Only project Manager can login and organize the project</i>
          </p>
          <button
            type="button"
            className="btn btn-outline-dark"
            onClick={() => {
              history.push('/login');
            }}
          >
            Login
          </button>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-6">
            <div className="d-flex align-items-center">
              <img
                className="img-landing p-4"
                src={process.env.PUBLIC_URL + '/img/phone-fixed.png'}
                alt="Android Phone"
              />
              <div className="d-flex flex-column">
                <span className="title-type"> Android </span>
                <span className="subtitle-head">
                  Android Development Project
                </span>
              </div>
            </div>
          </div>
          <div className="col-xl-6 grey-blank"></div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-6 grey-blank"></div>
          <div className="col-xl-6">
            <div className="d-flex justify-content-end lappy-flex">
              <div className="d-flex flex-column">
                <span className="title-type text-right"> Website </span>
                <span className="subtitle-head">
                  Website Development Project
                </span>
              </div>
              <img
                className="img-landing-lappy my-4"
                src={process.env.PUBLIC_URL + '/img/lappy.png'}
                alt="Android Phone"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container-project">
        <div className="d-flex flex-column lappy-flex">
          <p className="pm-title"> OUR PROJECTS </p>
          <div className="container">
            <div className="row">
              {arr.map((item, idx) => {
                return (
                  <div key={idx} className="col-4 col-md-2 text-center">
                    <img
                      className="logo-app"
                      src={process.env.PUBLIC_URL + `/img/logo/${item + 1}.png`}
                      alt="Android Phone"
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <button
            type="button"
            className="btn btn-outline-secondary see-more"
            onClick={() => {
              history.push('/project');
            }}
          >
            SEE MORE
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandingPageBody;
